import type { Template } from "@/types";

export const LA_06_H1_V5: Template[] = [
    {
        id: "la-05-h1v5-01",
        name: "LA 01 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 107, y: 108, width: 228, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 108, width: 227, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 39, width: 413, height: 258, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 806, y: 305, width: 133, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 947, y: 305, width: 132, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1087, y: 305, width: 132, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-02",
        name: "LA 02 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 183, y: 54, width: 310, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 792, y: 54, width: 143, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 792, y: 274, width: 143, height: 212, rotation: 0, imageRotation: 0 },     
            { id: "4", x: 943, y: 54, width: 293, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 274, width: 143, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1094, y: 274, width: 142, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-03",
        name: "LA 03 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 174, y: 285, width: 325, height: 202, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 174, y: 54, width: 159, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 341, y: 54, width: 158, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 799, y: 54, width: 279, height: 432, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1086, y: 54, width: 139, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1086, y: 274, width: 139, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-04",
        name: "LA 04 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 145, y: 54, width: 386, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 145, y: 283, width: 124, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 277, y: 283, width: 123, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 408, y: 283, width: 123, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 789, y: 103, width: 221, height: 334, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 103, width: 221, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-05",
        name: "LA 05 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 117, y: 54, width: 442, height: 272, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 117, y: 334, width: 105, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 334, width: 105, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 334, width: 105, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 456, y: 334, width: 104, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 862, y: 54, width: 303, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-06",
        name: "LA 06 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 82, y: 73, width: 512, height: 398, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 757, y: 73, width: 124, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 757, y: 276, width: 124, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 73, width: 252, height: 397, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1149, y: 73, width: 122, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1149, y: 276, width: 122, height: 194, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-07",
        name: "LA 07 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_07.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 128, y: 67, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 128, y: 275, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 67, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 264, y: 275, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 400, y: 67, width: 566, height: 408, rotation: 0, imageRotation: 0 },
            { id: "6", x: 974, y: 67, width: 262, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-08",
        name: "LA 08 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 84, width: 235, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 243, y: 84, width: 235, height: 374, rotation: 0, imageRotation: 0 },
            { id: "3", x: 486, y: 84, width: 492, height: 374, rotation: 0, imageRotation: 0 },
            { id: "4", x: 986, y: 84, width: 236, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1230, y: 84, width: 122, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1230, y: 276, width: 122, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-09",
        name: "LA 09 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 97, y: 66, width: 149, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 274, width: 149, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 254, y: 66, width: 565, height: 407, rotation: 0, imageRotation: 0 },
            { id: "4", x: 984, y: 66, width: 271, height: 407, rotation: 0, imageRotation: 0 },           
            { id: "5", x: 827, y: 66, width: 149, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 827, y: 274, width: 149, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-10",
        name: "LA 10 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_10.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 0, y: 207, width: 187, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 195, y: 207, width: 187, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 207, width: 380, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 778, y: 207, width: 187, height: 290, rotation: 0, imageRotation: 0 },
            { id: "5", x: 973, y: 207, width: 186, height: 290, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1167, y: 207, width: 186, height: 290, rotation: 0, imageRotation: 0 }
        ],
    }
];